import commonFn from '@/commons/commonFunction';
import {MSConstant} from '@/commons/wildcards';
import callbackFileCheckAPI from '@/apis/other/callbackFileCheckAPI.js';
import exchangeWorkerAPI from '@/apis/other/exchangeWorkerAPI.js';
import store from '@/stores/store';
import popupUtil from '@/commons/popupUtil';
import WebSocketAPI from '@/apis/system/socketAPI.js';
import _ from 'lodash';
import indexedDB from '@/commons/indexedDB';
import httpClient from '@/apis/base/httpclient';
import {showError} from '@/commons/globalMessage';
import {useToast} from 'vue-toast-notification';

import {
  ModuleNotification,
  ModuleContext,
  ModuleDbOption,
  ModuleBudgetSource,
  ModuleBudgetSourceProperty,
  ModuleBudgetPlanImplementation,
  ModuleBudgetSituation,
  ModuleCashBalanceDeposit,
  ModulePayableDebt,
  ModuleReceivableDebt,
  ModuleResultActivity,
  ModuleSurplusDeficit,
  ModuleUsingIncomeAndExpense,
  ModuleUsingSaving,
  ModuleAccountingObjectCache,
  ModuleOpeningAccountEntry,
} from '@/stores/moduleConst';
import moment from 'moment';

const actions = {
  /**
   * Event xuất khẩu grid từ websocket bắn về
   * @param {*} sender
   * @param {*} res
   * NCPHUOC 11/08/2022
   */
  'websocket-global-export-grid': async (sender, res) => {
    if (res) {
      const data = JSON.parse(res);
      if (!data) {
        return;
      }
      const context = store.state[ModuleContext];
      if (data.TabId !== context.TabId) {
        return;
      }
      const {Data} = data;
      if (Data) {
        clearTimeout(state.timeOutSocket);
        const link = callbackFileCheckAPI.getFileLink(MSConstant.StorageFileType.Temp, Data.fileName, Data.name);
        commonFn.downloadLink(link);
        commonFn.unmask();
        setTimeout(() => {
          // Log để tracking websocket
          WebSocketAPI.logTracking('export-grid', data.TabId);
        }, 200);
      }
    }
  },
  'websocket-global-dashboard-data': async (sender, res) => {
    if (!res) return;
    let dataJson = JSON.parse(res);
    let data = dataJson.data;
    let dataParam = dataJson?.parameter;
    delete data.DataParam;
    // Xử lý dữ liệu trả về
    if (data) {
      switch (dataParam.Chart) {
        case 1:
          data = [0, data.amountUsed, data.amountRest];
          break;
        case 2:
          if (data.AdvanceArises || data.AdvanceSurplus || data.ActualArises || data.ActualSurplus) {
            data = [
              {
                name: 'Số tạm ứng',
                data: [data.AdvanceArises, data.AdvanceSurplus],
              },
              {
                name: 'Số thực chi',
                data: [data.ActualArises, data.ActualSurplus],
              },
            ];
          } else {
            data = [];
          }
          break;
        case 3:
          break;
        case 4:
          break;
        case 5:
          if (data.Income != 0 || data.Expense != 0 || data.ExpenseWelfare != 0) {
            data = [data.Income, data.Expense, data.ExpenseWelfare];
          } else {
            data = [];
          }
          break;
        case 6:
          break;
        case 7:
          break;
        case 8:
          data = data;
          break;
        case 9:
          data = data;
          break;
      }
    }
    const EXPIREDTIME = 900;
    if (!dataParam) return;
    // Xử lý dữ websocket trả về để cập nhật dữ liệu dashboard
    const mappingKeyChart = {
      1: 'BudgetPlanImplementation',
      2: 'BudgetSituation',
      3: 'SurplusDeficit',
      4: 'ResultActivity',
      5: 'UsingSaving',
      6: 'UsingIncomeAndExpense',
      7: 'CashBalanceDeposit',
      8: 'PayableDebt',
      9: 'ReceivableDebt',
    };
    const mappingModule = {
      1: ModuleBudgetPlanImplementation,
      2: ModuleBudgetSituation,
      3: ModuleSurplusDeficit,
      4: ModuleResultActivity,
      5: ModuleUsingSaving,
      6: ModuleUsingIncomeAndExpense,
      7: ModuleCashBalanceDeposit,
      8: ModulePayableDebt,
      9: ModuleReceivableDebt,
    };
    const normalizeData = payload => {
      if (!payload) return null;
      const chart = payload.Chart;
      const clonePayload = _.cloneDeep(payload);
      let validPayload = {};
      const newBudgetSources = [],
        newBudgetKinds = [];
      switch (chart) {
        case 1:
          delete clonePayload.ToDate;
          if (clonePayload.BudgetSources) {
            clonePayload.BudgetSources.forEach(x => {
              newBudgetSources.push({
                budget_source_id: x.budget_source_id,
                budget_source_code: x.budget_source_code,
                budget_source_name: x.budget_source_name,
              });
            });
          }
          if (clonePayload.BudgetKinds) {
            clonePayload.BudgetKinds.forEach(x => {
              newBudgetKinds.push({
                budget_kind_item_code: x.budget_kind_item_code,
              });
            });
          }
          validPayload = {
            Chart: clonePayload.Chart,
            BudgetSubKindItem: clonePayload.BudgetSubKindItem,
            Unit: clonePayload.Unit,
            ToDate: clonePayload.ToDate,
            EstimateNumber: clonePayload.EstimateNumber,
            BudgetSources: newBudgetSources,
            BudgetKinds: newBudgetKinds,
            IsSummaryBudgetKind: clonePayload.IsSummaryBudgetKind,
            IsSummaryBudgetSource: clonePayload.IsSummaryBudgetSource,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 2:
          if (clonePayload.BudgetSources) {
            clonePayload.BudgetSources.forEach(x => {
              newBudgetSources.push({
                budget_source_id: x.budget_source_id,
                budget_source_code: x.budget_source_code,
                budget_source_name: x.budget_source_name,
              });
            });
          }
          if (clonePayload.BudgetKinds) {
            clonePayload.BudgetKinds.forEach(x => {
              newBudgetKinds.push({
                budget_kind_item_id: x.budget_kind_item_id,
                budget_kind_item_code: x.budget_kind_item_code,
              });
            });
          }
          validPayload = {
            FromDate: clonePayload.FromDate,
            ToDate: clonePayload.ToDate,
            IsSummaryBudgetKind: clonePayload.IsSummaryBudgetKind,
            IsSummaryBudgetSource: clonePayload.IsSummaryBudgetSource,
            Unit: clonePayload.Unit,
            Chart: clonePayload.Chart,
            BudgetKinds: newBudgetKinds,
            BudgetSources: newBudgetSources,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 3:
          validPayload = {
            FromDate: clonePayload.FromDate,
            ToDate: clonePayload.ToDate,
            IsSummary: clonePayload.IsSummary,
            Unit: clonePayload.Unit,
            Chart: clonePayload.Chart,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 4:
          validPayload = {
            FromDate: clonePayload.FromDate,
            ToDate: clonePayload.ToDate,
            IsSummary: clonePayload.IsSummary,
            Unit: clonePayload.Unit,
            Chart: clonePayload.Chart,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 5:
          validPayload = {
            FromDate: clonePayload.FromDate,
            ToDate: clonePayload.ToDate,
            Unit: clonePayload.Unit,
            Chart: clonePayload.Chart,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 6:
          validPayload = {
            FromDate: clonePayload.FromDate,
            ToDate: clonePayload.ToDate,
            Unit: clonePayload.Unit,
            Chart: clonePayload.Chart,
            IsFirst: clonePayload.IsFirst,
            IsSummary: clonePayload.IsSummary,
            Activities: clonePayload.Activities,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 7:
          delete clonePayload.ToDate;
          validPayload = {
            Unit: clonePayload.Unit,
            Chart: clonePayload.Chart,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 8:
          delete clonePayload.ToDate;
          validPayload = {
            Chart: clonePayload.Chart,
            Unit: clonePayload.Unit,
            IsFirst: clonePayload.IsFirst,
          };
          break;
        case 9:
          delete clonePayload.ToDate;
          validPayload = {
            Chart: clonePayload.Chart,
            Unit: clonePayload.Unit,
            IsFirst: clonePayload.IsFirst,
          };
          break;
      }
      delete clonePayload.ForceReload;
      delete clonePayload.TriggerLoadData;
      return JSON.stringify(validPayload);
    };
    let expired = moment(new Date());
    expired.add(EXPIREDTIME, 's');

    const indexDb = new indexedDB();
    const key = `cacheDashboard_${mappingKeyChart[dataParam?.Chart]}`;
    const newDashboardObject = {
      payload: normalizeData(dataParam),
      dataDashboard: data,
    };
    let datas = await indexDb.get(key);
    if (!datas) {
      newDashboardObject.expired = expired;
      indexDb.set(key, [newDashboardObject]);
    } else {
      const dataExist = datas.find(x => x.payload == newDashboardObject.payload);
      if (dataExist) {
        newDashboardObject.expired = dataExist.expired;
        datas = datas.filter(x => x.payload != newDashboardObject.payload);
        datas.push(newDashboardObject);
        await indexDb.set(key, datas);
      } else {
        newDashboardObject.expired = expired;
        datas.push(newDashboardObject);
        await indexDb.set(key, datas);
      }
    }
    const module = mappingModule[dataParam?.Chart];
    if (module) {
      await store.dispatch(`${module}/setItems`, data);
    }
  },
  /**
   * Event xuất khẩu grid từ websocket bắn về
   * @param {*} sender
   * @param {*} res
   * NCPHUOC 11/08/2022
   */
  'websocket-global-export-xml-finance': async (sender, res) => {
    if (res) {
      const data = JSON.parse(res);
      if (!data) {
        return;
      }
      const context = store.state[ModuleContext];
      if (data.TabId !== context.TabId) {
        return;
      }
      const {Data} = data;
      if (Data) {
        clearTimeout(state[Data.exportId]);
        const link = callbackFileCheckAPI.getFileLink(MSConstant.StorageFileType.Temp, Data.fileName, Data.name);
        commonFn.downloadLink(link);
        commonFn.unmask();
        setTimeout(() => {
          // Log để tracking websocket
          WebSocketAPI.logTracking('xml-finance', data.TabId);
        }, 200);
      }
    }
  },

  /**
   * Thông báo bắn về
   * @param {*} sender
   * @param {*} res
   */
  'websocket-global-notification': async (sender, res) => {
    if (res) {
      const data = JSON.parse(res);
      const dataInfo = JSON.parse(data.data);
      const context = store.state[ModuleContext];
      clearTimeout(state.timeOutSocket);
      // nếu là thông báo tạo dữ liệu thì chỉ push cho riêng user đó
      if (data.type == 18 || data.type == 19) {
        if (dataInfo && context.TenantId == dataInfo.tenant_id) {
          store.dispatch(`${ModuleNotification}/pushNotification`, data);
        }
      }
      // Với thông báo của Sao chép dữ liệu thì chỉ bắn thông báo cho DL đích
      else if (data.type == 22 || data.type == 23) {
        if (dataInfo && context.DatabaseId == dataInfo.to_database_id) {
          store.dispatch(`${ModuleNotification}/pushNotification`, data);
        }
      } else if (data.type == 10) {
        // Sắp xếp số chứng từ
        if (dataInfo.result) {
          let sortResult = {
            process_id: dataInfo.process_id,
            data: dataInfo.result,
          };
          store.dispatch(`${ModuleContext}/updateSortRefNoResult`, sortResult);
        }
      } else if (data.type === MSConstant.NotificationType.GetDataPrevYear) {
        //Check xem tab hiện tại có đang lấy số dư đầu năm không?
        var isGettingPrevYear = commonFn.getSessionStorage('IsGettingPrevYear');

        //Nếu tab hiện tại đang không thực hiện lấy số dư đầu năm thì không làm gì cả
        if (!isGettingPrevYear) {
          return;
        }

        //Show thông báo thành công/thất bại
        if (dataInfo.is_success) {
          //Toast hiển thị chính giữa, thời gian đóng 10s
          const config = {...(window._toastConfig || {}), position: 'top', duration: 10000};
          const toast = useToast(config);

          //Load lại dữ liệu tree số dư tài khoản
          await store.dispatch(`${ModuleOpeningAccountEntry}/loadTree`, {
            columns: 'account_number,account_name,debit_amount,credit_amount,account_id,parent_id',
          });

          //Ẩn tất cả popup để quay về màn danh sách số dư tài khoản
          popupUtil.hideAll();

          toast.success('Lấy số dư thành công');
        } else {
          switch (dataInfo.error_code) {
            case 'CREATE_DATA_PREV_YEAR':
              showError(
                'Không tìm thấy thông tin dữ liệu được chọn. Vui lòng kiểm tra lại dữ liệu bạn đã chọn.',
                'Chọn dữ liệu không thành công',
              );
              break;
            case 'ERROR_STARTDATE':
              showError('Bạn đã chọn sai dữ liệu kế toán. Vui lòng kiểm tra lại.', 'Lấy số dư không thành công');
              break;
            case 'NOT_FIT_DICTIONARY':
              showError(
                'Danh mục thay đổi so với dữ liệu cũ, vui lòng sửa lại danh mục hoặc tự nhập lại số dư đầu năm.',
                'Lấy số dư không thành công',
              );
              break;
            default:
              showError('Đã có lỗi xảy ra, vui lòng liên hệ với MISA để được hỗ trợ.', 'Lấy số dư không thành công');
              break;
          }
          console.log('Lấy số dư không thành công: ', dataInfo);
        }

        //Tắt loading hiện tại
        commonFn.unmask();

        //Cập nhật key đang lấy số dư đầu năm về false để không show thông báo từ websocket bắn về nữa
        commonFn.setSessionStorage('IsGettingPrevYear', false);
      } else {
        store.dispatch(`${ModuleNotification}/pushNotification`, data);
      }
    }
  },

  /**
   * Thông báo cập nhật tùy chọn in bắn về
   * @param {*} sender
   * @param {*} res
   * tbngoc 07.02.2023
   */
  'websocket-global-report-setting': async (sender, res) => {
    const context = store.state[ModuleContext];
    if (res) {
      clearTimeout(state.timeOutSocket);
      let data = JSON.parse(res);
      if (data && Array.isArray(data) && data.length > 0) {
        // Cập nhật thông tin vào cache
        const key = ['printMenu', data[0].ref_type, context.DatabaseId].join('');
        commonFn.setSessionStorage(key, res);
      }

      //store.dispatch(`${ModuleNotification}/pushNotification`, data);
    }
  },
  /**
   * Thông báo invalid cache từ server
   * @param {*} sender
   * @param {*} res
   * NCPHUOC 09/11/2022
   */
  'websocket-global-invalid-cache-di': async (sender, res) => {
    const context = store.state[ModuleContext];
    const mimosaClientId = context.TabId;
    if (res) {
      const data = JSON.parse(res);
      if (data) {
        const {version, client, module, type} = data;
        //Tạm thời một số module có cập nhật dư thừa sẽ load lại fullcache luôn
        //TVDAT 13/02/2023
        const redundantModules = [
          {
            currentModule: ModuleBudgetSourceProperty,
            redundantModule: ModuleBudgetSource,
          },
        ];
        let redundantModuleUpdate = redundantModules.find(f => f.currentModule == module);

        if (redundantModuleUpdate) {
          await store.dispatch(`${redundantModuleUpdate.redundantModule}/loadFullCache`, {remoteVersion: version});
        } else if (client !== mimosaClientId) {
          await store.dispatch(`${module}/loadFullCache`, {remoteVersion: version});
        } else if (type == MSConstant.InvalidCacheActionType.Import) {
          await store.dispatch(`${module}/loadFullCache`, {remoteVersion: version});
        }
      }
    }
  },

  /**
   * Thông báo là bắt đầu convert dữ liệu của db nào đó
   * @param {*} sender
   * @param {*} res
   * nvtoan2 06/12/2022
   */
  // 'websocket-global-start-convert': async (sender, res) => {
  //   if (res) {
  //     const socketData = JSON.parse(res);

  //     store.dispatch(`${ModuleContext}/insertDatabaseConverting`, [JSON.parse(socketData.data)?.database_id]);
  //     store.dispatch(`${ModuleContext}/insertCacheTimeConvert`, {
  //       database_id: JSON.parse(socketData.data)?.database_id,
  //       time: new Date()
  //     });
  //   }
  // },

  /**
   * Thực hiện sao lưu, phục hồi dữ liệu
   * @param {*} sender
   * @param {*} res
   * nmtuan4 01/02/2023
   * ntloc 25/05/2023: bổ sung thêm trường thông tư để case riêng
   */
  'websocket-global-backup-restore': async (sender, res) => {
    if (res) {
      const socketData = JSON.parse(res);

      const context = store.state[ModuleContext];

      if (socketData.action == 'remove' && socketData.notification) {
        store.dispatch(`${ModuleNotification}/pushNotification`, JSON.parse(socketData.notification));
      }

      switch (socketData?.type) {
        case MSConstant.BusyDatabaseType.Backup:
          store.dispatch(`${ModuleContext}/${socketData.action}DatabaseBackuping`, {
            database_id: socketData?.database_id,
            database_name: socketData?.database_name,
            backup_database_name: socketData.backup_database_name,
            current_percent: socketData.current_percent,
            is_success: socketData.is_success,
            type: MSConstant.BackupType.Backup,
            circular: socketData.circular,
          });
          break;
        case MSConstant.BusyDatabaseType.Restore:
          store.dispatch(`${ModuleContext}/${socketData.action}DatabaseRestoring`, {
            database_id: socketData?.database_id,
            database_name: socketData?.database_name,
            current_percent: socketData.current_percent,
            type: MSConstant.BackupType.Backup,
            is_success: socketData.is_success,
          });
          break;
        case MSConstant.BusyDatabaseType.Store:
          store.dispatch(`${ModuleContext}/${socketData.action}DatabaseBackuping`, {
            database_id: socketData?.database_id,
            database_name: socketData?.database_name,
            backup_database_name: socketData.backup_database_name,
            current_percent: socketData.current_percent,
            is_success: socketData.is_success,
            type: MSConstant.BackupType.Store,
            circular: socketData.circular,
          });
          break;
        case MSConstant.BusyDatabaseType.RestoreStore:
          store.dispatch(`${ModuleContext}/${socketData.action}DatabaseRestoring`, {
            database_id: socketData?.database_id,
            database_name: socketData?.database_name,
            current_percent: socketData.current_percent,
            type: MSConstant.BackupType.Store,
            is_success: socketData.is_success,
          });
          break;
      }
    }
  },

  'websocket-global-create-data-prev-year': async (sender, res) => {
    if (res) {
      const socketData = JSON.parse(res);
      store.dispatch(`${ModuleContext}/updateCreateDataProcess`, {
        DatabaseName: socketData.DatabaseName,
        Percent: socketData.PercentageCompleted,
        DatabaseShowType: MSConstant.DatabaseShowType.CreateData,
        DatabaseStatus: MSConstant.DatabaseStatus.CreateData,
      });
    }
  },

  /**
   * Đăng xuất tất cả các user trong room có token khác với token trong "res"
   * @param {*} sender
   * @param {*} res: Kết quả trả về từ socket
   * nxchien 27.01.2023
   */
  'websocket-global-logout-other-user': async (sender, res) => {
    if (res) {
      const socketData = JSON.parse(res);
      // lấy ra deviceId của user đang đăng nhập
      let deviceId = store.getters[`${ModuleContext}/DeviceId`];
      let budgetCode = store.getters[`${ModuleContext}/BudgetCode`];
      if (
        process.env.NODE_ENV !== 'development' &&
        socketData &&
        socketData.device_id != deviceId &&
        socketData.budgetCode == budgetCode
      ) {
        commonFn.logoff();
      }
    }
  },
  /**
   * Đăng xuất tất cả các user đã không được chọn sau khi xác nhận tối đa user
   * @param {*} sender
   * @param {*} res: Kết quả trả về từ socket
   * NBTIN 15.03.2023
   */
  'websocket-global-logout-over-user': async (sender, res) => {
    if (res) {
      const socketData = JSON.parse(res);
      // lấy ra deviceId của user đang đăng nhập
      let userId = store.getters[`${ModuleContext}/UserID`];
      if (socketData.userIds.includes(userId)) {
        commonFn.logoff();
      }
    }
  },

  /**
   * Đồng bộ dboption
   * @param {*} sender
   * @param {*} res
   * nmtuan4 12.01.2023
   */
  'websocket-global-update-db-option': async (sender, res) => {
    const socketData = JSON.parse(res);
    store.dispatch(`${ModuleDbOption}/updateCacheDbOptions`, socketData);
  },

  /**
   * Chạy progress chuyển đổi
   * @param {*} sender
   * @param {*} res
   * nvtoan2 19/04/2023
   */
  'websocket-global-convert-progress': async (sender, res) => {
    const context = store.state[ModuleContext];
    const data = JSON.parse(res);

    store.dispatch(`${ModuleContext}/updateConvertProgress`, {...data, DatabaseName: context.DatabaseName});

    if (data.CurrentPercent != 100) {
      store.dispatch(`${ModuleContext}/insertDatabaseConverting`, [data.DatabaseId]);

      if (context.DatabaseId == data.DatabaseId) {
        store.dispatch(`${ModuleContext}/atcDisabledConvert`, true);

        if (!popupUtil.get('ConvertLoadingPopup')) {
          popupUtil.show('ConvertLoadingPopup', {
            desktopDatabaseName: data.DesktopDatabaseName,
            desktopVersion: data.DesktopVersion,
            databaseName: data.DatabaseName,
          });
        }
      }
    }
  },

  /**
   * Chạy tiến trình Sao chép dữ liệu
   * @param {*} sender
   * @param {*} res
   * dtnga3 (06.06.2023)
   */
  'websocket-global-copy-data-progress': async (sender, res) => {
    const context = store.state[ModuleContext];
    const data = JSON.parse(res);
    let isCancel = false;
    if (context && context.CopyDataProgress) {
      var progress = context.CopyDataProgress.find(x => x.ToDatabaseId == data.ToDatabaseId);
      if (progress && progress.IsCancel) {
        isCancel = true;
      }
    }
    if (!isCancel) {
      store.dispatch(`${ModuleContext}/updateCopyDataProgress`, {...data, DatabaseName: context.DatabaseName});

      if (data.CurrentPercent != 100) {
        store.dispatch(`${ModuleContext}/insertDatabaseCopyData`, [data.ToDatabaseId]);
      }

      // Kiểm tra để mở lên form tiến trình nếu là DL gốc hoặc DL đích
      if (context.DatabaseId == data.ToDatabaseId || context.DatabaseId == data.FromDatabaseId) {
        if (!popupUtil.checkVisibleName('CopyDataLoadingPopup')) {
          popupUtil.show('CopyDataLoadingPopup', {
            to_database_name: data.ToDatabaseName,
            from_database_name: data.FromDatabaseName,
            to_database_id: data.ToDatabaseId,
            from_database_id: data.FromDatabaseId,
            HistoryCopyDataId: data.HistoryCopyDataId,
            isCallCopy: false,
          });
        }
      }
    }
  },

  'websocket-global-update-dvc': async (sender, res) => {
    const context = store.state[ModuleContext];
    let userDVC = JSON.parse(localStorage.DVCUser);
    if (res && userDVC) {
      const dataRes = JSON.parse(res);
      const dataRs = JSON.parse(dataRes.data);
      const pagingParam = dataRs.pagingParam;
      const dataSendMonitorCount = dataRs.dataSendMonitorCount;
      const workerId = dataRs.workerId;

      clearInterval(state[workerId]);

      let token = ''; // Gán rỗng để server không push lên worker cập nhật trạng thái hồ sơ nữa
      let dvcApprover = localStorage.getItem('DVCApprover');
      let userType = userDVC.user_type;
      const callAnalysisMonitor = async () => {
        let context = store.state[ModuleContext],
          param = {
            ApplicationCode: 'MMO',
            SubAppCode: 'DVC-Gateway',
            SubSystemCode: MSConstant.SubSystemCode.DVCUser,
            SubSystemName: MSConstant.SubSystemCode.DVCUser,
            TypeLevel: 0,
            UnitName: null,
            Url: window.location.href,
            User: context.FullName,
            UserID: context.UserID,
            Action: 'Change',
            ActionDetail: 'Save',
            OrganizationID: context.TenantId,
            OrganizationName: context.TenantName,
            Role: null,
            BudgetCode: context.BudgetCode,
            TaxCode: null,
            ActionDate: new Date(),
            DatabaseId: context.DatabaseId,
            DatabaseName: context.DatabaseName,
          };

        let config = {
          url: window._monitor.analysis,
          data: JSON.stringify(JSON.stringify(param)),
        };

        await httpClient.postAsync(config);
      };

      // Hồ sơ giao dịch
      if (dataRes.type == 32) {
        let columns =
          'file_code,title_file,state_treasury_name,sent_date,list_ref_no,file_status,state_treasury_status,dvc_file_id,description,user_type,budget_code,approving_by,accountant_approved,chief_accountant_approved';
        // param load danh sách
        const paramList = {
          Token: token,
          columns: columns,
          dvcApprover: dvcApprover,
          filter: pagingParam.Filter,
          lastModifiedDate: pagingParam.lastModifiedDate,
          reportYear: pagingParam.reportYear,
          sort: pagingParam.Sort,
          take: pagingParam.Take,
          type: 0,
          skip: pagingParam.Skip,
          userType: userType,
        };
        // param load tổng số
        const paramSummary = {
          Token: token,
          columns: columns,
          dvcApprover: dvcApprover,
          filter: pagingParam.Filter,
          lastModifiedDate: pagingParam.lastModifiedDate,
          sumColumns: 'total_amount:sum',
          type: 1,
          skip: pagingParam.Skip,
          userType: userType,
        };
        store.dispatch(`dVCFile/load`, paramList);
        store.dispatch(`dVCFile/loadSummary`, paramSummary);
      }

      // Hồ sơ đối chiếu
      if (dataRes.type == 33) {
        let columns =
          'dcsd_file_id,state_treasury_code,state_treasury_name,file_code,treasury_file_code,company_code,file_status,ktt_approve,ctk_approve,valid,parent_budget_code,budget_code,title_file,status,created_date,reason_reject,reason_path,sign_data,user_type,approving_by,accountant_approved,chief_accountant_approved';

        // param load danh sách
        const paramListDCSD = {
          token: token,
          columns: columns,
          dvcApprover: dvcApprover,
          filter: pagingParam.Filter,
          sort: pagingParam.Sort,
          take: pagingParam.Take,
          type: 0,
          skip: pagingParam.Skip,
          userType: userType,
        };
        // param load tổng số
        const paramSummaryDCSD = {
          token: token,
          columns: columns,
          dvcApprover: dvcApprover,
          filter: pagingParam.Filter,
          type: 1,
          skip: pagingParam.Skip,
          userType: userType,
        };
        store.dispatch(`dCSDFile/load`, paramListDCSD);
        store.dispatch(`dCSDFile/loadSummary`, paramSummaryDCSD);
      }

      //push MCP các hồ sơ được phê duyệt
      for (let i = 0; i < dataSendMonitorCount; i++) {
        callAnalysisMonitor();
      }
    }
  },

  /**
   * Thực hiện gọi hàm trong timeout tránh trường hợp websocket ko hoạt động
   * @param {*} storageType
   * @param {*} fileName
   * @param {*} name
   * nmtuan4 27.11.2023
   */
  handleTimeoutWorker(sender, {workerId, callbackFn}) {
    const timeoutPull = window._appConfig?.timeoutPull?.common || 10000; // Nếu websoket ko hoạt động thì 10s call lại 1 lần.
    const countInterval = 5; //Call 5 lần mà ko đc thì thôi
    let runInterVal = 0;

    //Tạo 1 timer để auto chạy trong TH websocket ko hoạt động
    const timeout = setInterval(async () => {
      if (countInterval === runInterVal) {
        clearInterval(timeout);
        delete state[workerId];
        callbackFn();
        console.log(`Run count ${runInterVal}`);
        return;
      }
      runInterVal++;
      try {
        const status = await exchangeWorkerAPI.checkStatus(workerId); // Kiểm tra đã chạy woker xong thì gọi callbackFn
        if (status == MSConstant.ExchangeStatus.Success || status == MSConstant.ExchangeStatus.Error) {
          callbackFn(status);
          clearInterval(timeout);
          delete state[workerId];
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    }, timeoutPull);

    state[workerId] = timeout;
  },

  // /**
  //  * Xử lý xuất khẩu báo cáo mẫu merge
  //  * npcuong 07.02.2023
  //  */
  // 'websocket-global-export-merge-report': async (sender, res) => {
  //   const socketData = JSON.parse(res);
  //   if (socketData) {
  //     var data = socketData.Data;
  //     if (data) {
  //       const link = callbackFileCheckAPI.getFileLink(MSConstant.StorageFileType.Temp, data.fileName, data.name);
  //       commonFn.downloadLink(link);
  //     }
  //   }
  // },

  /**
   * Thực hiện gọi hàm trong timeout tránh trường hợp websocket ko hoạt động
   * @param {*} storageType
   * @param {*} fileName
   * @param {*} name
   * NCPHUOC 11/08/2022
   * edit by dqvinh 19.4.2023
   */
  async exportTimeoutDownload(sender, {storageType, fileName, name}) {
    const timeoutPull = window._appConfig?.timeoutPullDownload?.timeoutPull || 5000; // Nếu websoket ko hoạt động thì 5s call lại 1 lần.
    const countInterval = window._appConfig?.timeoutPullDownload?.countInterval || 10; //Call 10 lần mà ko đc thì thôi
    let runInterVal = 0;
    //Tạo 1 timer để auto chạy trong TH websocket ko hoạt động
    const timeout = setInterval(async () => {
      if (countInterval === runInterVal) {
        clearInterval(timeout);
        commonFn.unmask();
        console.log(`Run count ${runInterVal}`);
        return;
      }
      runInterVal++;
      try {
        const res = await callbackFileCheckAPI.checkFileTemp(storageType, fileName, name);
        const link = callbackFileCheckAPI.getFileLink(storageType, fileName, name);
        // Modified: HMDUC2: Task 435207: Xử lý lại kết quả trả ra  từ 404 -> 200
        if (res && res != '') {
          commonFn.downloadLink(link);
          commonFn.unmask();
          clearInterval(timeout);
          setTimeout(() => {
            // Log để tracking websocket
            const context = store.state[ModuleContext];
            WebSocketAPI.logTracking('xml-finance', context.TabId, true);
          }, 200);
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    }, timeoutPull);

    state.timeOutSocket = timeout;
  },

  /**
   * Thực hiện gọi hàm trong timeout tránh trường hợp websocket ko hoạt động
   * @param {*} storageType
   * @param {*} fileName
   * @param {*} name
   * NCPHUOC 11/08/2022
   * modified by Ptthuy2 15.05.2023
   */
  exportTimeoutDownloadMultiple(sender, {storageType, fileName, name, exportId}) {
    const timeoutPull = window._appConfig?.timeoutPull?.exportFile || 10000; // Nếu websoket ko hoạt động thì 5s call lại 1 lần.
    const countInterval = 5; //Call 5 lần mà ko đc thì thôi
    let runInterVal = 0;

    //Tạo 1 timer để auto chạy trong TH websocket ko hoạt động
    const timeout = setInterval(async () => {
      if (countInterval === runInterVal) {
        clearInterval(timeout);
        delete state[exportId];
        commonFn.unmask();
        console.log(`Run count ${runInterVal}`);
        return;
      }
      runInterVal++;
      try {
        const res = await callbackFileCheckAPI.checkFileTemp(storageType, fileName, name);
        const link = callbackFileCheckAPI.getFileLink(storageType, fileName, name);
        if (link != null && link != '') {
          commonFn.downloadLink(link);
          commonFn.unmask();
          clearInterval(timeout);
          delete state[exportId];
        }
      } catch (error) {
        console.log(error);
      } finally {
      }
    }, timeoutPull);

    state[exportId] = timeout;
  },
  /**
   * Thực hiện gọi hàm tải về mẫu trộn trong trường hợp websocket không hoạt động
   * @param {*} storageType
   * @param {*} fileName
   * @param {*} name
   * npcuong 03.03.2023
   */
  exportTimeoutDownloadMergeReport(sender, {storageType, fileName, downloadName, exportId}) {
    const timeoutPull = window._appConfig?.timeoutPull?.exportFile || 10000;
    const timeout = setTimeout(() => {
      const link = callbackFileCheckAPI.getFileLink(storageType, fileName, downloadName);
      commonFn.downloadLink(link);
      commonFn.unmask();
    }, timeoutPull);

    state[exportId] = timeout;
  },
  /**
   * Get link preview mẫu trộn
   * @param {*} storageType
   * @param {*} fileName
   * @param {*} name
   * pqdat 29.05.2023
   */
  exportGetPreviewLinkMergeReport(sender, {storageType, fileName, downloadName, exportId}) {
    return callbackFileCheckAPI.getPreviewLink(storageType, fileName, downloadName);
  },
  /**
   * Get link preview mẫu trộn
   * @param {*} storageType
   * @param {*} fileName
   * @param {*} name
   * pqdat 29.05.2023
   */
  exportGetDownloadLinkMergeReport(sender, {storageType, fileName, downloadName, exportId}) {
    return callbackFileCheckAPI.getFileLink(storageType, fileName, downloadName);
  },
  /**
   * Reload màn hình danh sách hóa đơn sau khi phát hành thành công
   * @param {*} sender
   * @param {*} res: Kết quả trả về từ socket
   * NBTIN 13.10.2023
   */
  'websocket-global-publish-success': async (sender, res) => {
    if (res) {
      var context = store.state[ModuleContext];
      var invoice_type = store.state[ModuleDbOption]?.dbOptions.MeInvoiceUseInvoiceWithCode ? 2 : 1;
      var firstDayOfYear = moment(new Date(context.PostedDate.getFullYear(), 0, 1)).format('YYYY-MM-DD');
      var lastDayOfYear = moment(new Date(context.PostedDate.getFullYear(), 11, 31)).format('YYYY-MM-DD');
      const paramList = {
        take: 20,
        filter: `[{\"field\":\"inv_date\",\"value\":\"${firstDayOfYear}\",\"operator\":\">=\",\"Alias\":\"ssi\"},{\"field\":\"inv_date\",\"value\":\"${lastDayOfYear}\",\"operator\":\"<=\",\"Alias\":\"ssi\"},{\"Field\":\"ref_type\",\"Operator\":\"=\",\"Alias\":\"ssi\",\"Value\":701},{\"Field\":\"invoice_type\",\"Operator\":\"=\",\"Value\":${invoice_type}}]`,
        columns:
          'inv_date,inv_no,inv_template_no,inv_series,accounting_object_name,total_amount,publish_status,invoice_code,invoice_status,send_email_status,is_posted,payment_method,transaction_id,ref_id,accounting_object_id,ref_type,invoice_type',
        sort: 'inv_date DESC, publish_status ASC, inv_no DESC, accounting_object_name ASC',
        InvoiceType: 1,
        FilterNoInvoiceType: `[{\"field\":\"inv_date\",\"value\":\"${firstDayOfYear}\",\"operator\":\">=\",\"Alias\":\"ssi\"},{\"field\":\"inv_date\",\"value\":\"${lastDayOfYear}\",\"operator\":\"<=\",\"Alias\":\"ssi\"},{\"Field\":\"ref_type\",\"Operator\":\"=\",\"Alias\":\"ssi\",\"Value\":701}]`,
        type: 0,
      };
      const paramSummary = {
        columns:
          'inv_date,inv_no,inv_template_no,inv_series,accounting_object_name,total_amount,publish_status,invoice_status,send_email_status,is_posted,payment_method,ref_id,accounting_object_id,ref_type,invoice_type',
        type: 1,
      };
      store.dispatch(`sASaleInvoice/load`, paramList);
      store.dispatch(`sASaleInvoice/loadSummary`, paramSummary);
    }
  },

  /**
   * Lấy KH,NCC, Cán bộ thường xuyên sử dụng
   * @param {*} sender
   * @param {*} res
   * dtnga3 (21.12.2023)
   */
  'websocket-global-update-used-regularly': async (sender, res) => {
    const noti = JSON.parse(res);
    const data = JSON.parse(noti.data);
    const indexDb = new indexedDB();
    if (data) {
      await store.dispatch(`${ModuleAccountingObjectCache}/setItems`, data);
      await indexDb.set('cacheDi_accountingObjectCache', {
        localVersion: '',
        localData: data,
      });
    }
  },

  /**
   * gọi api update quyền khi nhận được socket thông báo
   * @param {*} sender
   * @param {*} res
   *  ldduy 8.1.2024
   */
  'websocket-global-update-permission': async (sender, res) => {
    const data = JSON.parse(res);
    if (data) {
      if (data.listUserId.includes(store.state[ModuleContext].Context.UserID)) {
        console.log('Bạn vừa có quyền mới');
        const result = await store.dispatch(
          `${ModuleContext}/updatePermission`,
          store.state[ModuleContext].Context.UserID,
        );
      }
    }
  },
};

const state = {
  timeOutSocket: 1,
};
export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  actions,
};
